import { Row, Space, Typography } from "antd";
import { TFunction } from "i18next";
import { useState } from "react";
import ArrowRight from "../../../assets/icons/arrow-right-white.svg";
import BecomingCreatorModalComponent from "../../../components/BecomingCreatorModalComponent";
import { authService } from "../../../services";

interface Props {
  t: TFunction<"translation", undefined, "translation">;
}

export default function BecomeCreator({ t }: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = async () => {
    try {
      await authService.signOut();
    } catch {
      authService.clearTokens();
    }
    window.location.replace("/auth/signUp?currentTab=creator");
  };

  return (
    <>
      <Row className="mt-10">
        <Space className="w-full gap-6" direction="vertical">
          <Typography.Text className="font-16-bold text-white-color">{t("account-type")}</Typography.Text>
          <Typography.Text className="font-13-bold user-type text-medium-green-color">
            <Space>
              <Row className="accountType" align="middle">
                <Typography.Text className="font-13-bold text-black-color">{t("auth-tab-fan")}</Typography.Text>
              </Row>
              <Row className="accountTypeBecomingCreator" align="middle" onClick={() => setIsOpen(true)}>
                <Space>
                  <Typography.Text className="font-13-bold text-white-color">{t("become-creator")}</Typography.Text>
                  <img src={ArrowRight} alt="" />
                </Space>
              </Row>
            </Space>
          </Typography.Text>
        </Space>
      </Row>
      <BecomingCreatorModalComponent
        isOpen={isOpen}
        title={t("what-is-a-creator")}
        paragraphs={[t("what-is-a-creator-text")]}
        submitText={t("i-want-to-be-a-creator")}
        onClose={() => setIsOpen(false)}
        onSubmit={handleSubmit}
      />
    </>
  );
}
